import { type ContentOperation, ContentOperationStatus } from '../types';
import { randomUUID } from '../utils';

/**
 * Create an initial content operation.
 */
export function createContentOperation(input: Partial<ContentOperation>): ContentOperation {
    return {
        id: input.id ?? randomUUID(),
        createdAt: Date.now(),
        updatedAt: Date.now(),
        updateId: 0,
        expireAfter: input.expireAfter || 60 * 10,
        status: ContentOperationStatus.STARTING,
        payload: input.payload || {},
        cursor: input.cursor ?? 0,
        target: input.target ?? 0,
    };
}
